import { IconRegistry } from '@tylertech/forge';
import { ForgeIcon } from '@tylertech/forge-react';
import { tylIconHome, tylIconShield } from '@tylertech/tyler-icons';
import './SideNav.css';

IconRegistry.define([tylIconHome, tylIconShield]);

export default function SideNav({ navRoutes, activeNavKey, onNavigate }) {
  const handleClick = (event, routeKey) => {
    if (onNavigate) {
      event.preventDefault();
      onNavigate(routeKey);
    }
  };

  return (
    <nav className="side-nav" aria-label="Account navigation">
      <ul className="side-nav__list">
        {navRoutes.map(route => {
          const isSelected = activeNavKey === route.key;
          return (
            <li key={route.key}>
              <a
                href={route.hash}
                className={`side-nav__link${isSelected ? ' side-nav__link--active' : ''}`}
                aria-current={isSelected ? 'page' : undefined}
                onClick={e => handleClick(e, route.key)}
              >
                {route.navIcon ? <ForgeIcon name={route.navIcon} className="side-nav__icon" /> : null}
                <span>{route.navLabel}</span>
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
